import { createHoldingsQuery } from '@hcr/api/consumer'

import { HTTP_CONFIG } from '../../../../configs'

export const useHoldingsQuery = createHoldingsQuery(HTTP_CONFIG.API.Consumer.url)
